import { useEffect, useState } from "react";
import { useStore } from "react-redux";
import useMedia from "use-media";
import CommonUtil from '../../../common/commonUtil';
import { getCityListByCountry, getCountryListByArea } from "../../../const/RTCC";
import common from "../../../resources/RTCC/js/common/common";
import { RadioButton } from "../../atoms/RTCC/radioButton";
import { CheckboxListBox } from "../../molecules/RTCC/checkboxListBox";

const CheckListPopupContainer = (props) => {
    const { course, state, onClickOpenCheckListWindow, setSelectRecommendFlg } = props;
    const store = useStore();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupFlg = state.checkListPopup;
    let listName = "";
    let dataList = [];
    if (state.areaFlg) {
        listName = "area";
        dataList = store.getState().area;

    } else if (state.countryFlg) {
        listName = "country";
        dataList = store.getState().country;
    } else if (state.cityFlg) {
        listName = "city";
        dataList = store.getState().city;
    }

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        if(popupFlg){
            document.getElementById("checkListDecision").disabled = false;
        }
    }, [popupFlg]);

    // 選択した値をstoreに保存
    const onClickDecision = () => {
        // 二度押し防止
        document.getElementById("checkListDecision").disabled = true;
        const array = [];
        const elements = document.getElementsByName(listName);
        for (let i in elements) {
            if (elements[i].checked === true) {
                array.push(elements[i].value);
            }
        }

        let dispText = "";
        let paramId = "";
        for (let i in dataList) {
            let index = array.indexOf(dataList[i].value);
            if (index >= 0) {
                dataList[i].checked = true;
                dispText = dispText + (dispText == "" ? "" : ", ");
                if (state.areaFlg) {
                    dispText = dispText + dataList[i].text;
                } else {
                    dispText = dispText + dataList[i].label;
                }
                paramId = paramId + (paramId == "" ? "" : ", ");
                paramId = paramId + dataList[i].value;
            } else {
                dataList[i].checked = false;
            }
        }
        if (state.areaFlg) {
            store.dispatch({ type: "AREA", payload: { area: dataList } });
            store.dispatch({ type: "DISP_AREA", payload: { dispArea: dispText } });
            common.doPost(getCountryListByArea, { areaId: paramId }, afterGetCountryList)
            store.dispatch({ type: "KEYWORD", payload: { keyWord: "" } });
        } else if (state.countryFlg) {
            store.dispatch({ type: "COUNTRY", payload: { country: dataList } });
            store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: dispText } });
            common.doPost(getCityListByCountry, { countryId: paramId.split(", ") }, afterGetCityList)
            store.dispatch({ type: "KEYWORD", payload: { keyWord: "" } });
        } else if (state.cityFlg) {
            store.dispatch({ type: "CITY", payload: { city: dataList } });
            store.dispatch({ type: "DISP_CITY", payload: { dispCity: dispText } });
            store.dispatch({ type: "KEYWORD", payload: { keyWord: "" } });
            onClickOpenCheckListWindow();
        }
        if (setSelectRecommendFlg) {
            setSelectRecommendFlg(false);
        }
    };

    const afterGetCountryList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            // リスト作成
            if (data.countryList) {
                let dataList = CommonUtil.getCheckList(data.countryList, "countryId", "countryName", false);
                store.dispatch({ type: "COUNTRY", payload: { country: dataList } })
            }
            store.dispatch({ type: "CITY", payload: { city: [] } })
            store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: "選択なし" } });
            store.dispatch({ type: "DISP_CITY", payload: { dispCity: "選択なし" } });
        }
        onClickOpenCheckListWindow();
    }
    const afterGetCityList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            // リスト作成
            if (data.cityList) {
                let dataList = CommonUtil.getCheckList(data.cityList, "cityId", "cityName", false);
                store.dispatch({ type: "CITY", payload: { city: dataList } })
            }
            store.dispatch({ type: "DISP_CITY", payload: { dispCity: "選択なし" } });
        }
        onClickOpenCheckListWindow();
    }

    return (
        <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
            <div className="popupInner">
                <div className="closeBtn" id="js-close-btn" onClick={onClickOpenCheckListWindow}>
                </div>
                <h4 className="popupInnerText" >{state.popupTitle}</h4>
                {state.areaFlg ?
                    <RadioButton
                        data={dataList}
                        name={listName}
                        id={listName}
                        style={styles.divStyle}
                        labelClassName="radioLabel paymentOptionLabel"
                        inputClassName="onlyPlanRadio"
                    />
                    :
                    <CheckboxListBox
                        data={dataList}
                        name={listName}
                    />
                }
                <div className="buttonArea" >
                    <button id="checkListDecision" className="button" onClick={onClickDecision}>決 定</button>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};
export default CheckListPopupContainer;

const styles = {
    divStyle: {
        display: "flex",
        flexWrap: "wrap",
        width: "80%",
        textAlign: "left",
        alignContent: "center",
        margin: "60px 20px 30px 70px",
        fontSize: "small"
    }
}